import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  inject,
  OnDestroy,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { NgbOffcanvas, NgbOffcanvasRef } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { BranchService } from '../../services/branch.service';
import { DefaultBranchService } from '../../services/default-branch.service';
import { DateRangeSelectorComponent } from '../date-range-selector/date-range-selector.component';
import { MultiBranchSelectorComponent } from '../multi-branch-selector/multi-branch-selector.component';

export interface FilterOptions {
  startDate?: Date;
  endDate?: Date;
}
@Component({
  selector: 'app-side-modal',
  imports: [DateRangeSelectorComponent, CommonModule, MultiBranchSelectorComponent],
  templateUrl: './side-modal.component.html',
})
export class SideModalComponent implements OnInit, OnDestroy {
  @ViewChild('sideModal') sideModalTemplate!: TemplateRef<unknown>;
  @ViewChild(DateRangeSelectorComponent) dateRangeSelector!: DateRangeSelectorComponent;
  @Output() filtersChanged = new EventEmitter<FilterOptions>();
  private readonly offcanvasService = inject(NgbOffcanvas);
  private readonly defaultBranchService = inject(DefaultBranchService);
  private readonly branchService = inject(BranchService);

  isGearHidden = false;
  defaultBranchServiceSubscription: Subscription = new Subscription();

  ngOnInit(): void {
    this.defaultBranchServiceSubscription = this.defaultBranchService.defaultBranch$.subscribe(
      (value: boolean) => {
        this.isGearHidden = value;
      }
    );
  }

  ngOnDestroy(): void {
    this.defaultBranchServiceSubscription.unsubscribe();
  }

  open(content: TemplateRef<unknown>) {
    this.offcanvasService.open(content, {
      ariaLabelledBy: 'sales-settings',
      position: 'end',
    });
  }

  resetToDefault(): void {
    // Clear branch selection
    this.branchService.clearSelectedBranches();
    // Clear date range
    if (this.dateRangeSelector) {
      this.dateRangeSelector.clearDateRange();
    }
  }

  applyFilters(): void {
    if (this.dateRangeSelector) {
      this.dateRangeSelector.closeDatePicker();
    }
    this.emitFilters();
    this.offcanvasService.dismiss('Filters applied');
  }

  closeOffcanvas(offcanvas: NgbOffcanvasRef): void {
    if (this.dateRangeSelector) {
      this.dateRangeSelector.closeDatePicker();
    }
    offcanvas.dismiss();
  }

  private emitFilters(): void {
    const filters: FilterOptions = this.dateRangeSelector?.dateRange ?? {};
    this.filtersChanged.emit(filters);
  }
}
